import { GetAdministratorsResponse, GetSchemesResponse } from '@quromedical/models';
import { trpc } from 'trpc';

export class MedicalAidApi {
  public async getAdministrators(): Promise<GetAdministratorsResponse> {
    const result = await trpc.client.administrator.getAll.query();

    return result;
  }

  public async getSchemes(): Promise<GetSchemesResponse> {
    const result = await trpc.client.scheme.getAll.query();

    return result;
  }
}
